import React from 'react';
import './ExhibitionExhibitors.css'
import Header from '../components/layout/header';

import Footerr from '../components/layout/footer';
import { useState } from 'react';
import Preloader from '../components/common/preloader';
import Sec1p2 from '../sections/sec1-p2';
import Sec2p2 from '../sections/sec2-p2';



const Exhibitionexhibitorspage = () => {
    const [selectedCategory, setSelectedCategory] = useState(null);
        const [loading, setLoading] = useState(true);
        const [searchTerm, setSearchTerm] = useState("");
    return ( 
        <>
                 {loading && <Preloader onFinish={() => setLoading(false)} />}
            <main className='body-bg'>
                <Header />
                <Sec1p2  loading={loading}
                  selectedCategory={selectedCategory}
  setSelectedCategory={setSelectedCategory}
    searchTerm={searchTerm}
  setSearchTerm={setSearchTerm}/>
                <Sec2p2   selectedCategory={selectedCategory} 
  searchTerm={searchTerm}/>
            </main>
            <Footerr />
        </>
     );
}
 
export default Exhibitionexhibitorspage;